import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  printTitle: {
    fontWeight: 600,
    '@media print': {
      '&&': {
        color: 'black',
        fontWeight: 600,
      },
    },
  },
  readLabel: {
    padding: '2px',
    color: `${(theme as any).palette.primary.main}`,
    '@media print': {
      '&&': {
        color: 'black',
      },
    },
  },
  largeTextField: {
    width: '100%',
  },
  halfTextField: {
    width: '50%',
  },
  fieldLabel: {
    padding: '2px',
    '@media print': {
      '&&': {
        color: 'black',
      },
    },
  },
  rootInput: { borderRadius: '0px' },
  defaultColor: {
    color: `${(theme as any).palette.text.notes}`,
  },
  label: {
    fontSize: '1.14rem',
    flexWrap: 'nowrap',
    minWidth: '55px',
  },
  outsideDC: {
    width: '25px',
    minWidth: '20px',
    lineHeight: '1',
  },
  buttonRoot: {
    width: '25px',
    minWidth: '20px',
    lineHeight: '1',
    marginTop: '14px',
    marginRight: '10px',
  },
  radioButtonRoot: {
    width: '25px',
    minWidth: '20px',
    lineHeight: '1',
    marginTop: '12px',
    marginRight: '10px',
  },
  buttonLabel: {
    fontSize: '0.8rem',
  },
  buttonOutlined: {
    padding: '1px',
  },
  readOnly: {
    color: `${(theme as any).palette.text.notes}`,
    '&&:hover': {
      backgroundColor: 'transparent',
      cursor: 'default',
    },
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200,
  },
  boldTitle: {
    fontWeight: 600,
  },
}));
